var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5969",
    fillRule: "evenodd",
    d: "M19.5 2.25a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-15A2.25 2.25 0 0 1 4.5 2.25zm-15 1.5a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h3.75V3.75zm9.75 16.5h-4.5V3.75h4.5zm1.5 0h3.75a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-3.75z",
    clipRule: "evenodd"
  })));
};
export default Svg3;